<template>
  <div class="header wrapper">
    <div class="menu-wrapper">

      <div class="hamburger" @click="toggleMobMenu" v-if="$store.getters.isTablet"><i class="material-icons">menu</i></div>

      <ul class="menu" v-if="!$store.getters.isTablet">
        <li><router-link :to="{ name: 'index' }" exact>Home</router-link></li>
        <li><router-link :to="{ name: 'news' }">News</router-link></li>
        <li><router-link :to="{ name: 'gallery' }">Gallery</router-link></li>
        <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
        <li><router-link class="small" :to="{ name: 'about' }">about</router-link></li>
        <li><a href="http://whiteside.in.ua/" target="_blank" class="small">archive</a></li>
        <li v-if="$currentUser.id">
          <router-link
          class="small"
          :to="{ name: 'profile' }">
          Profile
          </router-link>
        </li>
        <li v-if="$currentUser.id">
          <button
            class="logout small"
            @click="logout">
            Logout
          </button>
        </li>
      </ul>

      <transition name="fade">
        <ul class="menu is-mobile" v-if="$store.getters.isTablet && isVisibleMobMenu" @click="handleMobMenuClick">
          <li @click="toggleMobMenu" v-if="isVisibleMobMenu"><i class="material-icons close-mob-menu">close</i></li>
          <li><router-link :to="{ name: 'index' }" exact>Home</router-link></li>
          <li><router-link :to="{ name: 'news' }">News</router-link></li>
          <li><router-link :to="{ name: 'gallery' }">Gallery</router-link></li>
          <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
          <li><router-link class="small" :to="{ name: 'about' }">about</router-link></li>
          <li><a href="http://whiteside.in.ua/" target="_blank" class="small">archive</a></li>
          <li @click="toggleMobMenu" v-if="isVisibleMobMenu"><i class="material-icons close-mob-menu">close</i></li>
        </ul>
      </transition>

    </div>

  </div>

</template>

<script>
  import * as authService from '../services/auth.service'

  export default {
    name: 'Header',
    data () {
      return {
        isVisibleMobMenu: false
      }
    },

    methods: {
      logout () {
        authService.makeLogout()
      },
      toggleMobMenu () {
        this.isVisibleMobMenu = !this.isVisibleMobMenu
      },
      handleMobMenuClick ($event) {
        if ($event.target.tagName === 'A') {
          this.toggleMobMenu()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  // menu transition animation
  .fade-menu-enter-active {
    transition: opacity .3s
  }
  .fade-menu-enter, .fade-menu-leave-to {
    opacity: 0
  }

  .header {
    font-family: $font-title;
    font-size: 36px;
    position: relative;

    .is-active {
      color: $color-font-main;
      border-bottom: 3px solid $color-font-main;
    }

    a {
      color: $color-font-main;
      text-decoration: none;
      &:hover {
        color: $color-font-main;
        opacity: 0.1;
      }
    }

    .menu-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 88px 0;
    }

    .menu {
      width: 100%;
      text-transform: uppercase;
      display: flex;
      justify-content: flex-end;

      li {
        padding-left: 40px;
        .small{
          font-size: 15px;
        }
      }

      .logout{
        color: $color-font-main;
        font-family: $font-title;
        text-transform: uppercase;
        @include button_base;
        font-weight: bold;
      }
    }

    .hamburger {
      cursor: pointer;
      .material-icons {
        font-size: 40px;
      }
    }

    .menu.is-mobile {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100vh;
      z-index: 100;
      top: 0;
      position: absolute;
      background-color: $color-body;

      .close-mob-menu {
        font-size: 40px;
        cursor: pointer;
      }

      li {
        padding: 10px 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue